import React, { useContext } from 'react'
import { Link } from 'react-router-dom'

import IpsaContext from '../../../../../context/IpsaContext'

import ClientDisplay from './ClientDisplay'
import LoadingWrapper from '../../../../../components/LoadingWrapper'
import HelloIntroBox from '../../../../../components/IntroBox'
import BackToPortal from '../../../../../components/BackToPortal'

const ListSidebar = ({ recentClients, promiseArea, refreshFunction, showClients }) => {
    return (
        <>
            <HelloIntroBox type="IPSA" />

            <ul className="button-list">
                <li>
                    <BackToPortal />
                </li>
            </ul>
            <div className="border-box">
                <h2>Recent Clients</h2>

                <ul id="client-list-side" className="client-list">
                    <LoadingWrapper area={promiseArea}>
                        {recentClients.length === 0 && <li>No recent clients</li>}
                        {showClients ? (
                            recentClients.map((client) => {
                                const { id, firstName, lastName, availableStatuses } = client
                                return (
                                    <ClientDisplay
                                        key={id}
                                        id={id}
                                        firstName={firstName}
                                        lastName={lastName}
                                        nextStatuses={availableStatuses}
                                        refreshList={() => {
                                            refreshFunction()
                                        }}
                                    ></ClientDisplay>
                                )
                            })
                        ) : (
                            <p>
                                <i>Clients Hidden, click Show Clients</i>
                            </p>
                        )}
                    </LoadingWrapper>
                </ul>
            </div>
        </>
    )
}

export default ListSidebar
